var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFuelDarker20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BEA55EB8-30C5-4045-8B33-668A1772406A_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Tehingud---Grouped",
    transform: "translate(-566.000000, -102.000000)",
    stroke: "#DD9C00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(566.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25-Copy-4",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Fuel_Darker_20px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66666667,19.1666667 L1.66666667,1.66666667 C1.66666667,0.75 2.47435897,0 3.46153846,0 L11.5384615,0 C12.525641,0 13.3333333,0.75 13.3333333,1.66666667 L13.3333333,19.1666667",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,3 L9.9,3 C9.95522847,3 10,3.04477153 10,3.1 L10,7.9 C10,7.95522847 9.95522847,8 9.9,8 L5.1,8 C5.04477153,8 5,7.95522847 5,7.9 L5,3.1 C5,3.04477153 5.04477153,3 5.1,3 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,9.16666667 L14.2857143,9.16666667 C15.3333333,9.16666667 16.1904762,9.91666667 16.1904762,10.8333333 L16.1904762,17.5 C16.1904762,18.4166667 17.047619,19.1666667 18.0952381,19.1666667 C19.1428571,19.1666667 20,18.4166667 20,17.5 L20,3.54166667 L16.1904762,0",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,19.1666667 L15,19.1666667",
    id: "Stroke-7"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFuelDarker20Px);
export default __webpack_public_path__ + "static/media/Icon_Fuel_Darker_20px.dd60ed67c5edbbf158e688a511f7ef9d.svg";
export { ForwardRef as ReactComponent };